var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HubConnectionBuilder } from '@microsoft/signalr';
import { randomId } from '@portkey-v1/utils';
import { SocketError } from './types/index.js';
export class BaseSignalr {
    constructor({ listenList }) {
        this.doOpen = ({ url, clientId }) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const signalr = new HubConnectionBuilder().withUrl(url).withAutomaticReconnect().build();
            this._listener(signalr);
            if (this.signalr)
                yield this.signalr.stop();
            yield signalr.start();
            yield signalr.invoke('Connect', clientId);
            this.connectionId = (_a = signalr.connectionId) !== null && _a !== void 0 ? _a : '';
            this.signalr = signalr;
            this.url = url;
            return signalr;
        });
        this.listen = (name, handler) => {
            const key = randomId();
            let _name = name;
            if (!this._messageMap[_name])
                this._messageMap[_name] = {};
            this._messageMap[_name][key] = handler;
            return {
                remove: () => {
                    delete this._messageMap[_name][key];
                },
            };
        };
        this.start = (...args) => {
            return this._checkSignalr().start(...args);
        };
        this.on = (...args) => {
            return this._checkSignalr().on(...args);
        };
        this.invoke = (...args) => {
            return this._checkSignalr().invoke(...args);
        };
        this.onClose = (...args) => {
            return this._checkSignalr().onclose(...args);
        };
        this.stop = (...args) => {
            return this._checkSignalr().stop(...args);
        };
        this.destroy = () => {
            this._messageMap = {};
            return this._checkSignalr().stop();
        };
        this.connectionId = '';
        this._messageMap = {};
        this.signalr = null;
        this._listenList = listenList;
    }
    _listener(signalr) {
        this._listenList.forEach(listenType => {
            signalr.on(listenType, (data) => {
                this._onReceiver({ Event: listenType, Data: data });
            });
        });
    }
    _onReceiver(data) {
        const callback = this._messageMap[data.Event];
        callback &&
            Object.values(callback).forEach(handler => {
                handler(data.Data);
            });
    }
    _checkSignalr() {
        if (!this.signalr)
            throw SocketError.notConnect;
        return this.signalr;
    }
}
